export default __webpack_public_path__ + "static/cfm-ai-features-preview-e2f06e63dce25387ab643c442f1d0025.mp4";